import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  & span {
    font-size: 14px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.darkGrey};
    white-space: nowrap;
  }

  & svg {
    height: 20px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    padding-left: 25px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.lightsSilver};
  }
`;
